import { render, staticRenderFns } from "./settlementRule.vue?vue&type=template&id=ec0c8830&scoped=true&"
import script from "./settlementRule.vue?vue&type=script&lang=js&"
export * from "./settlementRule.vue?vue&type=script&lang=js&"
import style0 from "./settlementRule.vue?vue&type=style&index=0&id=ec0c8830&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0c8830",
  null
  
)

export default component.exports